import { Cache } from './main.js'
import { traverse } from '@/modules/util/object'

export class HttpCache extends Cache {
	constructor(settings={}) {
		super('http-cache', settings, 'uid', (req) => `${new Date().getTime()}_${req.path}`)
	}

	async get(uid) {
		const item = await super.get(uid)
		if (!item) {
			return null
		}

		if (item.value?.path === '/saveinspection' && item.value?.request?.body) {
			try {
				let vehicle, inspection
				const body = JSON.parse(item.value.request.body)
				if (body.vehicle) {
					vehicle = JSON.parse(body.vehicle)
				}
				if (body.inspection) {
					inspection = JSON.parse(body.inspection)
				}

				const uids = []

				const search = (key, val, parent) => {
					if (val && val.uid) {
						uids.push(val.uid)
					}
				}

				await traverse(vehicle || {}, search)
				await traverse(inspection || {}, search)

				item.value.uids = uids
			} catch (e) {
				console.error('Failed to parse request body:', e)
			}
		}

		return item
	}
}